import { useTranslation } from 'react-i18next';
import { Button } from 'components/buttons/button';
import { ButtonMetadata, ButtonType } from 'components/buttons/button-types';

type BasicButtonProps = {
  onClose?: () => void;
  onClaim?: () => void;
  disabled?: boolean;
  hideClaim?: boolean;
  buttonTitle: string;
  analyticsComponentName?: string;
  analyticsAreaName?: string;
  customAnalytics?: any;
  additionalMetaProperties?: Partial<ButtonMetadata>;
};

function BasicButtons(props: BasicButtonProps) {
  const {
    onClaim,
    onClose,
    disabled = false,
    hideClaim = false,
    buttonTitle,
    analyticsComponentName = 'button',
    analyticsAreaName,
    customAnalytics = null,
    additionalMetaProperties,
  } = props;

  const { t } = useTranslation();

  return (
    <div className="d-flex gap-4 justify-content-center flex-wrap flex-sm-nowrap">
      <Button
        meta={{
          type: ButtonType.OutlineDark,
          title: t('buttons.back'),
          areaName: analyticsAreaName,
          ...(additionalMetaProperties ? additionalMetaProperties : {}),
          analyticsTitle: t('buttons.back'),
        }}
        onClick={onClose}
        analyticsComponentName={analyticsComponentName}
        customAnalytics={customAnalytics}
      />
      {!hideClaim ? (
        <Button
          meta={{
            disabled: disabled,
            type: ButtonType.Primary,
            title: buttonTitle,
            areaName: analyticsAreaName,
            ...(additionalMetaProperties ? additionalMetaProperties : {}),
          }}
          onClick={onClaim}
          analyticsComponentName={analyticsComponentName}
          customAnalytics={customAnalytics}
        />
      ) : undefined}
    </div>
  );
}

export default BasicButtons;